import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Menu,
  Home,
  Group,
  Description,
  Payments,
  UploadFile,
  School,
  Assignment,
  EmojiEvents,
  MedicalInformation,
  EditCalendar,
  CalendarMonth,
  AdminPanelSettings,
  Analytics,
  MailOutline,
  Settings,
  Person,
  Event,
  Hail,
  VerifiedUser,
  Close,
  Celebration,
} from "@mui/icons-material";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import ShuffleIcon from "@mui/icons-material/Shuffle";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import { useAuth } from "../context/AuthContext";
import axios from "axios";
import Bubble from "./Utiles/Bubble";
import logoDesktop from "../img/colenf.png";
import logoMobile from "../img/colenfmovil.png";

const Sidebar = ({ open, toggle }) => {
  const { usuario, token } = useAuth();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // --- Bubbles zona COLEGIADO (ya existentes)
  const [numCursos, setNumCursos] = useState(0);
  const [numCitasPendiente, setNumCitasPendiente] = useState(0);
  const [numCitasConfirmada, setNumCitasConfirmada] = useState(0);
  const [numInscripciones, setNumInscripciones] = useState(0);
  const [numInscrPendiente, setNumInscrPendiente] = useState(0);
  const [numPagosPendiente, setNumPagosPendiente] = useState(0);
  const [numSubvPendiente, setNumSubvPendiente] = useState(0);
  const [numTramitesPendiente, setNumTramitesPendiente] = useState(0);

  // --- Bubbles zona ADMIN (arreglados)
  const [numAdminColegiadosPendRol, setNumAdminColegiadosPendRol] = useState(0);
  const [numAdminCambiosPend, setNumAdminCambiosPend] = useState(0);
  const [numAdminTramitesPend, setNumAdminTramitesPend] = useState(0);
  const [numAdminSubvPend, setNumAdminSubvPend] = useState(0);
  const [numAdminCitasPend, setNumAdminCitasPend] = useState(0);
  const [numAdminPagosPend, setNumAdminPagosPend] = useState(0);

  // --- Configuración axios ---
  const API = process.env.REACT_APP_API_URL;
  const headers = { Authorization: `Bearer ${token}` };

  // --- Helpers robustos ---
  const pagedCountPeek = async (url, params = {}) => {
    try {
      const r1 = await axios.get(url, {
        headers,
        params: { ...params, page: 0, size: 1 },
      });
      const d1 = r1?.data ?? {};
      if (typeof d1.totalElements === "number") return d1.totalElements;
      if (d1.page && typeof d1.page.totalElements === "number") {
        return d1.page.totalElements;
      }
      const totalPages =
        typeof d1.totalPages === "number"
          ? d1.totalPages
          : typeof d1.page?.totalPages === "number"
            ? d1.page.totalPages
            : null;

      if (totalPages && totalPages > 0) {
        const rLast = await axios.get(url, {
          headers,
          params: { ...params, page: totalPages - 1, size: 1 },
        });
        const dLast = rLast?.data ?? {};
        const lastContent = Array.isArray(dLast?.content)
          ? dLast.content
          : Array.isArray(dLast)
            ? dLast
            : [];
        return (totalPages - 1) + lastContent.length;
      }
      if (Array.isArray(d1?.content)) return d1.content.length;
      if (Array.isArray(d1)) return d1.length;
      return 0;
    } catch {
      return 0;
    }
  };

  const norm = (v) => (v == null ? "" : String(v).trim().toUpperCase());

  // ----------------------
  // Bubbles para COLEGIADO
  // ----------------------
  useEffect(() => {
    if (!usuario || usuario.rol === "ADMIN") return;

    axios
      .get(`${API}/api/cursos`, { headers })
      .then((res) =>
        setNumCursos(
          (res.data || []).filter(
            (c) => c.disponible === 1 || c.disponible === true
          ).length
        )
      )
      .catch(() => { });

    axios
      .get(`${API}/api/citas/colegiado/${usuario?.codigo}`, { headers })
      .then((res) => {
        const raw = res.data ?? [];
        const xs = Array.isArray(raw)
          ? raw
          : Array.isArray(raw.content)
            ? raw.content
            : [];
        const estadoDe = (x) => norm(x.estado ?? x.titulo ?? x.status);
        const pendientes = xs.filter((c) => estadoDe(c) === "PENDIENTE").length;
        const confirmadas = xs.filter((c) => {
          const e = estadoDe(c);
          return e === "CONFIRMADA" || e === "CONFIRMADO" || e.startsWith("CONFIRM");
        }).length;
        setNumCitasPendiente(pendientes);
        setNumCitasConfirmada(confirmadas);
      })
      .catch(() => { });

    axios
      .get(`${API}/api/pagos/colegiado/${usuario?.codigo}`, { headers })
      .then((res) => {
        const raw = res.data || [];
        const lista = Array.isArray(raw)
          ? raw
          : Array.isArray(raw.content)
            ? raw.content
            : [];
        const pendientes = lista.filter((p) => {
          const estado = norm(p.estado ?? p.estado_pago ?? p.estadoPago);
          const pagadoFlag = p.pagado ?? p.isPagado ?? p.paid;
          if (estado === "PENDIENTE") return true;
          if (estado === "PAGADO") return false;
          if (typeof pagadoFlag === "boolean") return !pagadoFlag;
          return false;
        }).length;
        setNumPagosPendiente(pendientes);
      })
      .catch(() => { });

    axios
      .get(`${API}/inscripciones/mias`, { headers })
      .then((res) => {
        const inscripciones = res.data || [];
        setNumInscrPendiente(
          inscripciones.filter((i) => norm(i.estado) === "PENDIENTE").length
        );
        setNumInscripciones(
          inscripciones.filter((i) => norm(i.estado) === "PAGADA").length
        );
      })
      .catch(() => { });

    axios
      .get(`${API}/api/subvenciones/misSubvenciones`, {
        headers,
        params: { colegiadoId: usuario?.codigo },
      })
      .then((res) => {
        const arr = res.data || [];
        const estado = (s) => norm(s.estado ?? s.estado_subvencion ?? s.estadoSubvencion);
        setNumSubvPendiente(arr.filter((s) => estado(s) === "PENDIENTE").length);
      })
      .catch(() => { });

    axios
      .get(`${API}/api/colegiados/${usuario?.codigo}/tramites/page`, {
        headers,
        params: { page: 0, size: 1000 },
      })
      .then((res) => {
        const content = res?.data?.content || [];
        const estado = (t) => norm(t.estado ?? t.estado_tramite ?? t.estadoTramite);
        setNumTramitesPendiente(content.filter((t) => estado(t) === "PENDIENTE").length);
      })
      .catch(() => { });
  }, [usuario, token, API]);

  // ------------------
  // Bubbles para ADMIN
  // ------------------
  const totalElementsOf = (data) =>
    typeof data?.totalElements === "number"
      ? data.totalElements
      : typeof data?.page?.totalElements === "number"
        ? data.page.totalElements
        : Array.isArray(data?.content)
          ? data.content.length
          : Array.isArray(data)
            ? data.length
            : 0;

  useEffect(() => {
    if (!usuario || usuario.rol !== "ADMIN") return;

    const cargarColegiadosPendRol = async () => {
      try {
        const res = await axios.get(`${API}/api/admin/buscar`, {
          headers,
          params: { rol: "pendiente" },
        });
        const data = res?.data;
        const count = Array.isArray(data)
          ? data.length
          : Array.isArray(data?.content)
            ? data.content.length
            : typeof data?.conteo === "number"
              ? data.conteo
              : 0;
        setNumAdminColegiadosPendRol(count);
      } catch {
        setNumAdminColegiadosPendRol(0);
      }
    };

    const cargarCambiosPend = async () => {
      try {
        const res = await axios.get(`${API}/api/cambios/pendientes`, { headers });
        const data = res?.data;
        const count =
          typeof data === "number"
            ? data
            : typeof data?.conteo === "number"
              ? data.conteo
              : Array.isArray(data)
                ? data.length
                : 0;
        setNumAdminCambiosPend(count);
      } catch {
        setNumAdminCambiosPend(0);
      }
    };

    const cargarTramitesPend = async () => {
      try {
        const PAGE_SIZE = 200;
        let page = 0;
        let totalPages = null;
        let totalPend = 0;

        while (true) {
          const res = await axios.get(`${API}/api/colegiados-tramites/page`, {
            headers,
            params: { page, size: PAGE_SIZE },
          });

          const d = res?.data ?? {};
          const content = Array.isArray(d?.content)
            ? d.content
            : Array.isArray(d)
              ? d
              : [];

          totalPend += content.filter(
            (t) => norm(t.estado ?? t.estado_tramite ?? t.estadoTramite) === "PENDIENTE"
          ).length;

          if (totalPages == null) {
            totalPages =
              typeof d?.totalPages === "number"
                ? d.totalPages
                : typeof d?.page?.totalPages === "number"
                  ? d.page.totalPages
                  : null;
          }

          if (totalPages != null) {
            page++;
            if (page >= totalPages) break;
          } else {
            if (content.length < PAGE_SIZE) break;
            page++;
            if (page > 2000) break;
          }
        }

        setNumAdminTramitesPend(totalPend);
      } catch {
        setNumAdminTramitesPend(0);
      }
    };

    const cargarSubvPend = async () => {
      try {
        const r = await axios.get(`${API}/api/subvenciones/colegiados/subvenciones`, {
          headers,
          params: { page: 0, size: 1000 },
        });
        const content =
          Array.isArray(r?.data?.content) ? r.data.content : Array.isArray(r?.data) ? r.data : [];
        const count = content.filter(
          (s) => norm(s.estado ?? s.estado_subvencion ?? s.estadoSubvencion) === "PENDIENTE"
        ).length;
        setNumAdminSubvPend(count);
      } catch {
        setNumAdminSubvPend(0);
      }
    };

    const cargarCitasPend = async () => {
      try {
        const res = await axios.get(`${API}/api/citas`, { headers });
        const raw = res.data ?? [];
        const xs = Array.isArray(raw) ? raw : Array.isArray(raw.content) ? raw.content : [];
        const pendientes = xs.filter((c) => norm(c.estado ?? c.titulo ?? c.status) === "PENDIENTE").length;
        setNumAdminCitasPend(pendientes);
      } catch {
        setNumAdminCitasPend(0);
      }
    };

    const cargarPagosPend = async () => {
      try {
        const PAGE_SIZE = 200;
        let page = 0;
        let totalPages = null;
        let totalPend = 0;

        while (true) {
          const res = await axios.get(`${API}/api/pagos/page`, {
            headers,
            params: { page, size: PAGE_SIZE },
          });

          const d = res?.data ?? {};
          const content = Array.isArray(d?.content)
            ? d.content
            : Array.isArray(d)
              ? d
              : [];

          totalPend += content.filter((p) => {
            const estado = norm(p.estado ?? p.estado_pago ?? p.estadoPago);
            const pagadoFlag = p.pagado ?? p.isPagado ?? p.paid;
            if (estado === "PENDIENTE") return true;
            if (estado === "PAGADO") return false;
            if (typeof pagadoFlag === "boolean") return !pagadoFlag;
            return false;
          }).length;

          if (totalPages == null) {
            totalPages =
              typeof d?.totalPages === "number"
                ? d.totalPages
                : typeof d?.page?.totalPages === "number"
                  ? d.page.totalPages
                  : null;
          }

          if (totalPages != null) {
            page++;
            if (page >= totalPages) break;
          } else {
            if (content.length < PAGE_SIZE) break;
            page++;
            if (page > 2000) break;
          }
        }

        setNumAdminPagosPend(totalPend);
      } catch {
        setNumAdminPagosPend(0);
      }
    };

    cargarColegiadosPendRol();
    cargarCambiosPend();
    cargarTramitesPend();
    cargarSubvPend();
    cargarCitasPend();
    cargarPagosPend();
  }, [usuario, token, API]);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return (
    <>
      {/* botón hamburguesa */}
      {isMobile && (
        <div className="fixed top-0 left-0 z-50 w-16 h-14 bg-[#263858] flex items-center justify-center">
          <button
            onClick={toggle}
            className="text-white p-2 rounded-md hover:bg-white/20 transition"
          >
            {open ? <Close /> : <Menu />}
          </button>
        </div>
      )}

      <aside
        className={`bg-[#263858] text-white h-screen fixed top-0 left-0 transition-all duration-300 z-40 flex flex-col items-center pt-14 px-4 pb-4 overflow-hidden ${open ? (isMobile ? "w-64" : "w-64") : "w-16"
          }`}
      >
        {/* Zona fija (logo) */}
        <div className="flex items-center justify-center mb-2 shrink-0">
          <Link to="/">
            <img
              src={isMobile ? logoMobile : open ? logoDesktop : logoMobile}
              alt="EnferNET Logo"
              className="w-auto h-18 mt-2"
            />
          </Link>
        </div>

        {/* Zona scrollable (items) */}
        <nav
          className="flex flex-col space-y-1 w-full mt-2 flex-1 overflow-y-auto min-h-0 pr-1"
          style={{ scrollbarWidth: "thin" }}
        >
          {usuario?.rol === "ADMIN" ? (
            <>
              <NavItem
                to="/admin/colegiados"
                icon={<Group />}
                label="Colegiados"
                open={open}
                bubble={numAdminColegiadosPendRol}
              />
              <NavItem
                to="/admin/historico-cambios"
                icon={<Analytics />}
                label="Hist.Cambios"
                open={open}
                bubble={numAdminCambiosPend}
              />
              <NavItem
                to="/admin/documentos"
                icon={<Description />}
                label="Docs Colegiados"
                open={open}
              />
              <NavItem
                to="/admin/tramites"
                icon={<BusinessCenterIcon />}
                label="Trámites"
                open={open}
                bubble={numAdminTramitesPend}
              />
              <NavItem
                to="/admin/catalogos"
                icon={<MedicalInformation />}
                label="Catalogos"
                open={open}
              />
              <NavItem
                to="/admin/eventos"
                icon={<Celebration />}
                label="Eventos"
                open={open}
              />
              <NavItem
                to="/admin/subvenciones"
                icon={<UploadFile />}
                label="Subvenciones"
                open={open}
                bubble={numAdminSubvPend}
              />
              <NavItem to="/admin/cursos" icon={<School />} label="Cursos" open={open} />
              <NavItem to="/admin/premios" icon={<EmojiEvents />} label="Premios" open={open} />
              <NavItem
                to="/admin/pagos"
                icon={<Payments />}
                label="Pagos Fianzas"
                open={open}
                bubble={numAdminPagosPend}
              />
              <NavItem
                to="/admin/remesas"
                icon={<UploadFile />}
                label="Remesas / SEPA"
                open={open}
              />
              <NavItem to="/admin/registro" icon={<Assignment />} label="Registro" open={open} />
              <NavItem
                to="/admin/agenda"
                icon={<EditCalendar />}
                label="Agenda"
                open={open}
              />
              <NavItem
                to="/admin/citas"
                icon={<CalendarMonth />}
                label="Citas Renta"
                open={open}
                bubble={numAdminCitasPend}
              />
              <NavItem to="/admin/email" icon={<MailOutline />} label="Email" open={open} />
              <NavItem to="/admin/noticias" icon={<NewspaperIcon />} label="Noticias" open={open} />
              <NavItem to="/admin/random" icon={<ShuffleIcon />} label="Aleatorizador" open={open} />    
              <NavItem to="/admin/config" icon={<Settings />} label="Configuración" open={open} />
            </>
          ) : (
            <>
              <NavItem to="/dashboard" icon={<Home />} label="Inicio" open={open} />
              <NavItem to="/perfil" icon={<Person />} label="Area Colegiado" open={open} />

              <NavItem
                to="/inscripciones"
                icon={<School />}
                label="Cursos presenciales"
                open={open}
                bubble={numInscrPendiente}
              />

              <NavItem to="/documentos" icon={<Description />} label="Documentos" open={open} />

              <NavItem
                to="/citas"
                icon={<Event />}
                label="Citas Renta"
                open={open}
                bubble={numCitasPendiente}
              />

              <NavItem
                to="/eventos"
                icon={<Celebration />}
                label="Eventos"
                open={open}
              />

              <NavItem
                to="/tramites"
                icon={<BusinessCenterIcon />}
                label="Trámites"
                open={open}
                bubble={numTramitesPendiente}
              />

              <NavItem
                to="/subvenciones"
                icon={<UploadFile />}
                label="Subvenciones"
                open={open}
                bubble={numSubvPendiente}
              />

              <NavItem
                to="/pagos"
                icon={<Payments />}
                label="Pagos"
                open={open}
                bubble={numPagosPendiente}
              />

              <NavItem to="/historico" icon={<VerifiedUser />} label="Histórico" open={open} />
            </>
          )}
        </nav>
      </aside>
    </>
  );
};

const NavItem = ({ to, icon, label, open, bubble }) => (
  <Link to={to} className="flex items-center p-2 hover:bg-white/20 rounded transition">
    <div className="relative mr-2">
      {icon}
      {bubble > 0 && (
        <span className="absolute -top-3">
          <Bubble count={bubble} />
        </span>
      )}
    </div>
    {open && <span>{label}</span>}
  </Link>
);

export default Sidebar;
